import { LOCALE_ID, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CustomerModule } from '@rensa/modules/customer/customer.module';
import { SharedModule } from '@rensa/shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MsalInterceptor, MsalModule } from '@azure/msal-angular';
import { environment } from '@rensa/environments/environment';
import localeNl from '@angular/common/locales/nl';
import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

registerLocaleData(localeNl);

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AppRoutingModule,
    CustomerModule,
    SharedModule,
    BrowserModule,
    BrowserAnimationsModule,
    MsalModule.forRoot({
      auth: {
        clientId: environment.AADClientId,
        authority: environment.AADTenantId,
        redirectUri: environment.AADRedirectUri
      }, cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
      },
    }, {
      popUp: false,
      consentScopes: ['openid'],
      protectedResourceMap: [
        [environment.apiBaseUrlAdmin, ['openid']],
        [`${environment.apiBaseUrl}/roles`, ['openid']]
      ]
    })
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: MsalInterceptor,
    multi: true
  }, {
    provide: LOCALE_ID, useValue: 'nl-NL'
  }],
  bootstrap: [AppComponent]
})
export class AppModule {
}
